import { useNavigate } from "react-router-dom";

export const authCheck = async (tokenAuth = '') => {
	try {
		return await fetch(`/api/auth`, {
			headers: {
		  		'content-type': 'application/json',
		  		'x-token': tokenAuth
			},
			body: {},
			method: 'POST',
			mode: 'cors'
		})
		.then(response => {
			let json = response.json();
			if(!response.ok) {
		  		return json.then(Promise.reject.bind(Promise));
			}
			return json;
		})
		.then(results => {
			return results['data'] ? results['data'] : {};
		})
		.catch(error => {
			return {
				'error' : true,
				'message' : error.message
			}
      	});
    } catch (error) {
    	return {
			'error' : true,
			'message' : error.message
		}
    }

    return false;
}

export const fetchPatientDocument = async (tokenAuth = '', formIndex = 1) => {

	let queryStr = "";
	if(formIndex > 1) {
		queryStr = "?f=" + formIndex;
	}

	return await fetch(`/api/form${queryStr}`, {
		headers: {
		'content-type': 'application/json',
		'x-token': tokenAuth
		},
		method: 'GET',
		mode: 'cors'
	})
	.then(response => {
		let json = response.json();
		if(!response.ok) {
			return json.then(Promise.reject.bind(Promise));
		}
		return json;
	})
	.then(results => {
		if(results.hasOwnProperty('error')) {
		    const err = new Error(JSON.stringify(results['message']));
		    err.statusCode = 200;
		    throw err;
		}

		return results['data'].length > 0 ? results['data'][0] : {};
	})
	.catch(error => {
		if(error.statusCode == 200) {
			return {
				'error' : false,
				'message' : testJSON(error.message)
			}
		} else {
			return {
				'error' : true,
				'message' : testJSON(error.message)
			}
		}
	});
}

export const savePatientDocument = async (tokenAuth = '', submission, action = 'save', formIndex = 1) => {
	
	let queryStr = "";
	if(formIndex > 1) {
		queryStr = "?f=" + formIndex;
	}

	// Set Action
	submission['action'] = action;

	return await fetch(`/api/form${queryStr}`, {
	  headers: {
	    'content-type': 'application/json',
	    'x-token': tokenAuth
	  },
	  body: JSON.stringify(submission),
	  method: 'POST',
	  mode: 'cors'
	})
	.then(response => {
	  let json = response.json();
	  if(!response.ok) {
	    return json.then(Promise.reject.bind(Promise));
	  }
	  return json;
	})
	.then(results => {
	  if(results.hasOwnProperty('error')) {
	    const err = new Error(JSON.stringify(results['message']));
	    err.statusCode = 200;
	    throw err;
	  }

	  return results['data'] && results['data'] ? results['data'] : {};
	})
	.catch(error => {
	  if(error.statusCode == 200) {
	    return {
			'error' : false,
			'message' : testJSON(error.message)
		}
	  } else {
	    return {
			'error' : true,
			'message' : testJSON(error.message)
		}
	  }
	});
}

// Function to test string
const testJSON = (text) => {
    if (typeof text !== "string") {
        return text;
    }
    try {
        return JSON.parse(text);
    } catch (error) {
        return text;
    }
}